import { Link } from "react-router-dom";
import { siteConfig, footerLinks } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 hover:opacity-80 transition-opacity">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50 tracking-tight">{siteConfig.name}</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">{siteConfig.description}</p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">影视分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
            <div className="space-y-2.5 text-sm text-background-400">
              <p><i className="ri-mail-line mr-2"></i>contact@mitaomovie.com</p>
              <p><i className="ri-phone-line mr-2"></i>400-888-6666</p>
              <p><i className="ri-map-pin-line mr-2"></i>北京市朝阳区建国路88号</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">&copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.</p>
          <div className="flex items-center gap-3">
            {["ri-weibo-line", "ri-wechat-line", "ri-tiktok-line", "ri-bilibili-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-50 hover:bg-primary-600 transition-all duration-200"
                rel="nofollow"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}